/** Hosts shoppers may be sent to from catalog buy and affiliate links. */
const ALLOWED_BUY_HOSTS = new Set([
  "bestbuy.ca",
  "amazon.ca",
  "amzn.ca",
  "walmart.ca",
  "newegg.ca",
  "amazon.com",
  "walmart.com",
  "bestbuy.com",
  "newegg.com",
]);

function hostKey(hostname) {
  return String(hostname || "")
    .toLowerCase()
    .replace(/^www\./, "");
}

export function isAllowedBuyUrl(value) {
  try {
    const parsed = new URL(String(value || "").trim());
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return false;
    return ALLOWED_BUY_HOSTS.has(hostKey(parsed.hostname));
  } catch {
    return false;
  }
}

export function isHttpUrl(value) {
  try {
    const parsed = new URL(String(value || "").trim());
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}
